/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FileReadOnly } from "./FileReadOnly";
import {
  FileReadOnlyFromJSON,
  FileReadOnlyFromJSONTyped,
  FileReadOnlyToJSON,
  FileReadOnlyToJSONTyped,
} from "./FileReadOnly";
import type { UnitEnum } from "./UnitEnum";
import {
  UnitEnumFromJSON,
  UnitEnumFromJSONTyped,
  UnitEnumToJSON,
  UnitEnumToJSONTyped,
} from "./UnitEnum";
import type { Extent } from "./Extent";
import { ExtentFromJSON, ExtentFromJSONTyped, ExtentToJSON, ExtentToJSONTyped } from "./Extent";
import type { RasterTypeEnum } from "./RasterTypeEnum";
import {
  RasterTypeEnumFromJSON,
  RasterTypeEnumFromJSONTyped,
  RasterTypeEnumToJSON,
  RasterTypeEnumToJSONTyped,
} from "./RasterTypeEnum";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface PatchedRaster
 */
export interface PatchedRaster {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  type?: RasterTypeEnum;
  /**
   *
   */
  readonly threedimodel?: string | null;
  /**
   *
   */
  name?: string;
  /**
   *
   */
  readonly file?: FileReadOnly;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  epsgCode?: number | null;
  /**
   *
   */
  extent?: Extent;
  /**
   *
   */
  geotransform?: Array<number> | null;
  /**
   *
   */
  unit?: UnitEnum;
}

/**
 * Check if a given object implements the PatchedRaster interface.
 */
export function instanceOfPatchedRaster(value: object): value is PatchedRaster {
  return true;
}

export function PatchedRasterFromJSON(json: any): PatchedRaster {
  return PatchedRasterFromJSONTyped(json, false);
}

export function PatchedRasterFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedRaster {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    type: json["type"] == null ? undefined : RasterTypeEnumFromJSON(json["type"]),
    threedimodel:
      json["threedimodel"] === undefined
        ? undefined
        : json["threedimodel"] === null
        ? null
        : json["threedimodel"],
    name: json["name"] == null ? undefined : json["name"],
    file: json["file"] == null ? undefined : FileReadOnlyFromJSON(json["file"]),
    id: json["id"] == null ? undefined : json["id"],
    epsgCode:
      json["epsg_code"] === undefined
        ? undefined
        : json["epsg_code"] === null
        ? null
        : json["epsg_code"],
    extent: json["extent"] == null ? undefined : ExtentFromJSON(json["extent"]),
    geotransform:
      json["geotransform"] === undefined
        ? undefined
        : json["geotransform"] === null
        ? null
        : json["geotransform"],
    unit: json["unit"] == null ? undefined : UnitEnumFromJSON(json["unit"]),
  };
}

export function PatchedRasterToJSON(json: any): PatchedRaster {
  return PatchedRasterToJSONTyped(json, false);
}

export function PatchedRasterToJSONTyped(
  value?: Omit<PatchedRaster, "url" | "threedimodel" | "file" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: RasterTypeEnumToJSON(value["type"]),
    name: value["name"],
    epsg_code: value["epsgCode"],
    extent: ExtentToJSON(value["extent"]),
    geotransform: value["geotransform"],
    unit: UnitEnumToJSON(value["unit"]),
  };
}
